<template>
    <v-dialog
        v-model="dialog"
        :max-width="dialog_width"
        :persistent="saveLoading || archiveLoading"
    >
        <div class="tw-flex tw-flex-col side-site-padding tw-gap-2">
            <h2 class="tw-capitalize tw-text-secondary">
                {{ mode }} 669 Report
            </h2>
            <div class="pb-0">
                <v-form name="reportEditForm" ref="reportEditForm">

                    <!-- v-text-field for report_name -->
                    <v-text-field
                        v-model="modelObject.report_name"
                        label="Report Name"
                    ></v-text-field>

                    <!-- date-picker for report_date -->

                    <v-dialog
                        ref="dialog"
                        v-model="modal"
                        :return-value.sync="modelObject.report_date"
                        persistent
                        width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="modelObject.report_date"
                                label="Report Date"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="modelObject.report_date"
                            scrollable
                        >
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                color="primary"
                                @click="modal = false"
                            >
                                Cancel
                            </v-btn>
                            <v-btn
                                text
                                color="primary"
                                @click="$refs.dialog.save(modelObject.report_date)"
                            >
                                OK
                            </v-btn>
                        </v-date-picker>
                    </v-dialog>

                    <!-- v-file-input for report_path -->
                    <v-file-input
                        v-model="modelObject.new_report_path"
                        label="Report File"
                    ></v-file-input>

                </v-form>
            </div>
        </div>

        <div class="tw-flex tw-flex-row tw-justify-center tw-gap-3 mt-2">
            <v-btn
                text
                @click="archiveModel"
                class="btn-solid"
                :loading="archiveLoading"
                v-show="is_edit_mode"
            >
                Delete
            </v-btn>
            <v-btn
                text
                @click="cancelDialog"
                class="main-btn"
            >
                Cancel
            </v-btn>
            <v-btn
                text
                @click="saveModel"
                class="main-btn"
                :loading="saveLoading"
            >
                Save
            </v-btn>
        </div>
    </v-dialog>
</template>

<script>
export default {
    name: "Edit669ReportDialog",
    props: {
        'value': {
            // The visibility of the dialog.  To be used with `v-model`
            type: Boolean,
            required: true
        },
        'modelProp': {
            // The model we want to show details for (model is generic and don't require to be modified for each reuse of this modal)
            type: Object,
            required: false
        },
        'constants': {
            // The constants we will rely on
            type: Object,
            required: false
        },
        'valuelists': {
            // The constants we will rely on
            type: Object,
            required: false
        },
        'area': {
            // The area for the report (667 or 669)
            type: String,
            required: false
        },
    },
    updated() {
        //
    },
    data() {
        return {
            dialog: this.value || false,
            mode: '',
            modelObject: {},
            modelDefault: {
                id: null,
                report_name: null,
                new_report_path: null,
                report_date: null,
            },
            modal: false,
            saveLoading: false,
            archiveLoading: false,
            rules: {
                required: value => !!value || 'Required',
            },
        };
    },

    mounted() {
        //
    },
    computed: {

        dialog_width() {
            return '450px'
        },
        is_edit_mode() {
            return this.mode === 'Edit' ? true : false
        },
        getDepartments() {
            return [
                "BC",
                "Manitoba",
                "Saskatchewan",
                "New",
                "Alberta"
            ];
        }
    },
    methods: {
        cancelDialog() {
            if (!this.loading) {
                this.dialog = false
            }
        },
        saveModel() {
            if (this.$refs.reportEditForm.validate()) {

                let formData = new FormData()

                for (let key in this.modelObject) {
                    if (this.modelObject[key] !== null
                        && this.modelObject[key] !== undefined
                        && this.modelObject[key] !== 'undefined'
                    ) { // Adding three as system is not stable with this from time to time
                        formData.append(key, this.modelObject[key])
                    } else {
                        formData.append(key, '')
                    }
                }

                var url = ''

                if( this.is_edit_mode ) {
                    url = route('productionreports.update', this.modelObject.id)
                    formData.append("area", "669")
                    formData.append("_method", "put")
                } else {
                    formData.append("area", "669")
                    url = route('productionreports.store')
                }

                axios({
                    method: 'post',
                    url: url,
                    data: formData,
                    onUploadProgress: (evt) => {
                        this.saveLoading = !this.saveLoading
                    },
                    onDownloadProgress: (evt) => {
                        this.saveLoading = !this.saveLoading
                    },
                })
                    .then(response =>
                    {
                        if (response.data.success) {
                            this.$root.is_dirty = false
                            this.$root.snackbar.success('Changes have been saved')
                            this.$emit('successful-report-save', this.modelObject)
                            this.dialog = false
                            this.$root.is_dirty = false
                        } else if( response.data?.error ) {
                            throw (response.data?.error)
                        } else {
                            throw ('Unknown error.')
                        }
                    })
                    .catch((error) => {
                        this.saveLoading = false
                        this.$root.handleErrors(error)
                    })

            } else {
                this.$root.snackbar.error('Please fill all required fields.')
            }
        },
        async archiveModel() {
            if (confirm('Are you sure you want to delete this report?')) {
                try {
                    const response = await axios.delete(`/productionreports/${this.modelObject.id}`)
                    if (response.data.success) {
                        this.$root.snackbar.success('Report deleted successfully.')
                        this.dialog = false // Close the dialog
                        this.$emit('successful-report-save', this.modelObject.id)
                    } else if (response.data.error) {
                        throw response.data.error
                    } else {
                        throw 'Unknown error.'
                    }
                } catch (error) {
                    this.$root.handleErrors(error)
                }
            }
        },

        isUserAdmin() {
            if (this.$page.user.role === 'ADMIN') {
                return true
            } else {
                return false
            }
        },
    },
    watch: {
        value(newInput, oldInput) {
            this.dialog = newInput
        },
        dialog(newDialog, oldDialog) {
            this.$emit('input', newDialog)
            if (newDialog === false) {
                // Closing modal
                this.$refs.reportEditForm.resetValidation()
            } else {
                // Opening modal
                if (this.modelProp === null) {
                    this.mode = 'Add'
                    this.modelObject = structuredClone(this.modelDefault)
                } else {
                    this.mode = 'Edit'
                    this.modelObject = structuredClone(JSON.parse(JSON.stringify(this.modelProp)))
                }
            }
        },
    },
}

</script>

<style scoped>

</style>
